import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { UserRoleReference, Lang, Res } from 'src/app/models';
import { LanguageService, NotificationService, ApiOrgPositionsService, ValidatorsService } from 'src/app/services';
import { OrgRoleEditValidator } from '../org-role-edit/org-role-edit.validation';

@Component({
  selector: 'app-org-employee-position-actions',
  templateUrl: './org-employee-position-actions.component.html',
  styleUrls: ['./org-employee-position-actions.component.css']
})
export class OrgEmployeePositionActionsComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  loading: boolean;
  uroles: UserRoleReference[];
  org_id: string;
  positions: any;
  departments: any;
  positionId: string;
  positionName: Lang;
  userData: any;

  ffInputLangParams = {
    name: {
      clearField: true,
      required: true
    }
  }

  form: UntypedFormGroup = this.fb.group({
    id: [null],
    name: [null, Validators.required],
    managerial: [false]
  });

  @Input() set data(value) {

    if (value != null) {
      this.positionId = value.position_id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private apiOrgPositions: ApiOrgPositionsService,
    private validator: OrgRoleEditValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    if(this.positionId != null){
      this.onEdit();
    }

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  * @param fieldName string
  * @param value Lang
  */
  eventFnFF(fieldName: string, value: Lang): void {

    this.form.controls[fieldName].setValue(value);
  }


    /**
     * 
     */
    onCreate(): void {

      let form = { ...this.form.value }
  
      this.progressRef.start();
  
      this.subscriptions.add(
        this.apiOrgPositions.create(form).subscribe((response: Res) => {
          console.log('[RESPONSE] saveCertificate: ', response);
  
          if (response != null) {
  
            this.notification.show('success', 'Роль успешно создана!');
            this.activeModal.close(response);
          }
  
          this.progressRef.complete();
        },
          error => {
            this.progressRef.complete();
          })
      );
    }


  /**
  * 
  */
   onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiOrgPositions.edit(this.positionId).subscribe((response: Res) => {
        console.log('[RESPONSE] ORG_ROLE_EDIT: ', response);

        if (response != null) {

          this.positions = { ...response.result };

          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  
  /**
   * 
   */
   setDataInForm(data: any): any {
    
    this.positionName = this.positions.name;

    this.form.controls.id.setValue(data.id);
    this.form.controls.managerial.setValue(data.managerial);
  }


  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrgPositions.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] updateUserInfo: ', response);

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
  * 
  * @param field 
  * @param type 
  */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }

}